var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 32 32"}},[_c('circle',{attrs:{"r":_vm.radius,"cx":"16","cy":"16","stroke-width":"6","stroke-dasharray":"100 100"}}),_vm._v(" "),_c('circle',{attrs:{"r":_vm.radius,"cx":"16","cy":"16","stroke-width":"6","stroke-dasharray":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }